import SendResetPasswordEmailForm from '@src/features/tenant/auth/SendResetPasswordEmailForm';
import TenantCenterCardLayout from '@src/layouts/tenant/TenantCenterCardLayout';

function SendResetPasswordEmail() {
  return (
    <>
      <TenantCenterCardLayout>
        <SendResetPasswordEmailForm />
      </TenantCenterCardLayout>
    </>
  );
}

export default SendResetPasswordEmail;
